let totalSeconds = 2 * 60 * 60;
function updateTimer() {
  if (totalSeconds <= 0) {
    totalSeconds = 2 * 60 * 60;
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  document.getElementById('ig-hours').textContent = String(hours).padStart(2, '0');
  document.getElementById('ig-minutes').textContent = String(minutes).padStart(2, '0');
  document.getElementById('ig-seconds').textContent = String(seconds).padStart(2, '0');

  totalSeconds--;
}

updateTimer();
setInterval(updateTimer, 1000);